import React from "react";
import "./Rules_card.css";

function Rules_card({ number, rule }) {
  return (
    <section className="Rules_card">
      <div className="rules_section">
        <div className="heading_bg_holder">
          <div className="img_holder">
            <img
              src="/assets/images/Invitation_Reward_Rules/heading_bg.png"
              className="bg_img"
              alt="bg"
            />
          </div>

          <div className="rules_title">
            <p>Rule {number}</p>
          </div>
        </div>

        <p className="mt-3">{rule}</p>
      </div>
    </section>
  );
}

export default Rules_card;
